import React, { useMemo } from 'react';


import FireworksCanvas from '../components/FireworksCanvas/FireworksCanvas';
import hoaMai     from '../assets/hoa-mai-petal.png';
import hoaDao     from '../assets/hoadao.png';
import canhMai    from '../assets/hoa-mai-petal-to.png';
import phaoRight    from '../assets/longden3.png';

// Tài nguyên 8/3
import wdDaisy      from '../assets/daisy.png';
import wdBouquet    from '../assets/flower-bouquet.png';
import wdFlower     from '../assets/flower.png';
import wdButterfly  from '../assets/butterfly.png';
import wdBouquet2   from '../assets/bouquet.png';


import './themes.css';
function TetDecorations() {
  const petals = useMemo(
    () =>
      Array.from({ length: 10 }, () => ({
        type:     Math.random() < 0.55 ? 'mai' : 'dao',
        left:     Math.random() * 100,
        delay:    -Math.random() * 25,
        duration: 18 + Math.random() * 50,
        size:     12 + Math.random() * 18,
      })),
    []
  );

  return (
    <>
      <FireworksCanvas />

  
      <div className="tet-branch-left">
        <img src={canhMai} alt="" />
      </div>

     
      <div className="tet-petal-layer">
        {petals.map((p, idx) => (
          <img
            key={idx}
            src={p.type === 'mai' ? hoaMai : hoaDao}
            alt=""
            className="tet-petal"
            style={{
              left:              `${p.left}vw`,
              animationDelay:    `${p.delay}s`,
              animationDuration: `${p.duration}s`,
              width:             `${p.size}px`,
            }}
          />
        ))}
      </div>
      <div className="tet-firecracker tet-firecracker-right">
        <img src={phaoRight} alt="" />
      </div>
    </>
  );
}

function DoctorDayDecorations() {
  const items = useMemo(
    () =>
      Array.from({ length: 10 }, () => ({
        left:     Math.random() * 100,
        delay:    -Math.random() * 20,
        duration: 12 + Math.random() * 18,
        size:     14 + Math.random() * 20,
      })),
    []
  );

  return (
    <div className="dd-floating-layer">
      {items.map((item, idx) => (
        <span
          key={idx}
          className="dd-float-item dd-cross-sym"
          style={{
            left:              `${item.left}vw`,
            animationDelay:    `${item.delay}s`,
            animationDuration: `${item.duration}s`,
            fontSize:          `${item.size}px`,
          }}
        >
          ✚
        </span>
      ))}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  NGÀY QUỐC TẾ PHỤ NỮ 8/3
// ─────────────────────────────────────────────────────────────────────────────
const WD_IMAGES = [wdDaisy, wdBouquet, wdBouquet2, wdFlower, wdButterfly];

function WomenDayDecorations() {
  const items = useMemo(
    () =>
      Array.from({ length: 6 }, () => ({
        src:      WD_IMAGES[Math.floor(Math.random() * WD_IMAGES.length)],
        left:     Math.random() * 100,
        delay:    -Math.random() * 20,
        duration: 12 + Math.random() * 18,
        size:     16 + Math.random() * 16,
      })),
    []
  );

  return (
    <div className="wd-floating-layer">
      {items.map((item, idx) => (
        <img
          key={idx}
          src={item.src}
          alt=""
          className="wd-float-item"
          style={{
            left:              `${item.left}vw`,
            animationDelay:    `${item.delay}s`,
            animationDuration: `${item.duration}s`,
            width:             `${item.size}px`,
          }}
        />
      ))}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  NGÀY GIẢI PHÓNG MIỀN NAM 30/4
// ─────────────────────────────────────────────────────────────────────────────
function LiberationDayDecorations() {
  const stars = useMemo(
    () =>
      Array.from({ length: 22 }, (_, i) => ({
        id:       i,
        left:     Math.random() * 100,
        delay:    -(Math.random() * 12),
        duration: 6 + Math.random() * 8,
        size:     10 + Math.random() * 16,
        opacity:  0.55 + Math.random() * 0.45,
      })),
    []
  );

  return (
    <>
      {/* Ảnh nền mờ toàn màn hình */}
      <div
        className="ld-bg-image"
       // style={{ backgroundImage: "url('https://image.bvhvgl.com/images/Ch%E1%BB%8B%20Hi%E1%BB%81n%20CTXH/360%20%C4%91%E1%BB%99/e0ad0db498d84caa49efa7afccd60d3d.jpg')" }}
 
 
        style={{ backgroundImage: "url('https://image.bvhvgl.com/images/Ch%E1%BB%8B%20Hi%E1%BB%81n%20CTXH/360%20%C4%91%E1%BB%99/30-4/bacho.png')" }}

        
        
        

      />

      <div className="ld-star-layer">
        {stars.map((s) => (
          <span
            key={s.id}
            className="ld-star-item"
            style={{
              left:              `${s.left}vw`,
              animationDelay:    `${s.delay}s`,
              animationDuration: `${s.duration}s`,
              fontSize:          `${s.size}px`,
              opacity:           s.opacity,
            }}
          >
            ★
          </span>
        ))}
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  EXPORT
// ─────────────────────────────────────────────────────────────────────────────
export default function ThemeDecorations({ theme }) {
  if (theme?.decoration === 'tet')             return <TetDecorations />;
  if (theme?.decoration === 'doctor-day')      return <DoctorDayDecorations />;
  if (theme?.decoration === 'women-day')       return <WomenDayDecorations />;
  if (theme?.decoration === 'liberation-day') return <LiberationDayDecorations />;
  return null;
}
